class HeaderMenu {
  constructor(header) {
    this.header = header;
    this.dialog = header.querySelector('[data-mobile-menu]');
    this.openButton = header.querySelector('[data-mobile-menu-open]');
    this.closeButton = header.querySelector('[data-mobile-menu-close]');

    if (!this.dialog || !this.openButton || !this.closeButton) return;

    this.openButton.addEventListener('click', () => this.open());
    this.closeButton.addEventListener('click', () => this.close());
    this.dialog.addEventListener('close', () => this.afterClose());
    this.dialog.addEventListener('click', (event) => {
      if (event.target === this.dialog) this.close();
    });
  }

  open() {
    if (this.dialog.open) return;

    this.dialog.showModal();
    this.openButton.setAttribute('aria-expanded', 'true');
    document.documentElement.style.overflow = 'hidden';
    this.closeButton.focus();
  }

  close() {
    if (this.dialog.open) this.dialog.close();
  }

  afterClose() {
    this.openButton.setAttribute('aria-expanded', 'false');
    document.documentElement.style.overflow = '';
    this.openButton.focus();
  }
}

document.querySelectorAll('[data-site-header]').forEach((header) => {
  new HeaderMenu(header);
});
